import { useState } from "react";
import { toast } from "sonner";
import { createCheckoutSession } from "@/lib/api";

export const PRODUCTS = {
  FOUNDATION: "foundation_guide",
  ACTION: "action_bundle",
};

export const PRICING = {
  [PRODUCTS.FOUNDATION]: { display: "$50", numeric: 50 },
  [PRODUCTS.ACTION]: { display: "$95", numeric: 95 },
};

// The primary CTA everywhere except pricing cards
export const PRIMARY_PRODUCT = PRODUCTS.ACTION;
export const PRIMARY_PRICE_DISPLAY = PRICING[PRIMARY_PRODUCT].display;

export default function usePurchase(defaultProductId = PRIMARY_PRODUCT) {
  const [loadingId, setLoadingId] = useState(null);

  const purchase = async (productId = defaultProductId) => {
    if (loadingId) return;
    setLoadingId(productId);
    try {
      const { url } = await createCheckoutSession(productId);
      if (!url) throw new Error("No checkout URL returned");
      window.location.href = url;
    } catch (e) {
      console.error(e);
      toast.error("Could not start checkout. Please try again.");
      setLoadingId(null);
    }
  };

  return {
    purchase,
    loading: loadingId !== null,
    isLoading: (productId) => loadingId === productId,
  };
}
